enum UserPersonaTypes {
    WORD_POWER = 'wordpower',
    WORD_POWER_CA = 'wordpower_ca',
    NEWS_LETTER = 'newsletter',
    NEWS_LETTER_CA = 'newsletter_ca',
    FINANCIAL_FOUNDATION = 'financial_foundation',
    FINANCIAL_FOUNDATION_CA = 'financial_foundation_ca',
    PERSONAL_LINK = 'personal_link',
    PERSONAL_LINK_CA = 'personal_link_ca',
    PERSONAL_LINK_FA_PROFILE = 'personal_link_fa_profile',
    PERSONAL_LINK_FA_PROFILE_CA = 'personal_link_fa_profile_ca',
    DIRECT_URL_CA = 'direct_url_ca',
    DIRECT_URL = 'direct_url',
}

export default UserPersonaTypes;